import { FilebrowserDeploy } from "./filebrowserdeploy";
import { FilebrowserData } from "./filebrowserdata";
import { Github } from "./github";
import { CustomCommands } from "./customcommands";
import { Logs } from "./Logs";
import { PyJupyterlab } from "./pyjupyterlab";
import { Wordpress } from "./wordpress";

const renderCustomizations = (appName, app, getData, appBundleTechnology, lastDeployDatetime) => {
    switch (app?.technology) {
        case "wordpress":
            return <Wordpress appName={appName} app={app} getData={getData} />;
        case "pyjupyterlab":
            return <PyJupyterlab appName={appName} app={app} getData={getData} />;
        case "easyhosting":
            return <Github appName={appName} app={app} getData={getData} />;
        case "filebrowser":
            if (appBundleTechnology !== "easyhosting") {
                return <>
                    <FilebrowserData appName={appName} />
                    <FilebrowserDeploy appName={appName} app={app} getData={getData} lastDeployDatetime={lastDeployDatetime} />
                </>;
            }
            return <FilebrowserData appName={appName} />
        case "python":
            return <><Logs appName={appName} app={app} getData={getData} /><CustomCommands appName={appName} app={app} getData={getData} appBundleTechnology={appBundleTechnology} /><Github appName={appName} app={app} getData={getData} lastDeployDatetime={lastDeployDatetime} /></>;
        case "nodejs":
            return <><Logs appName={appName} app={app} getData={getData} /><CustomCommands appName={appName} app={app} getData={getData} appBundleTechnology={appBundleTechnology} /><Github appName={appName} app={app} getData={getData} lastDeployDatetime={lastDeployDatetime} /></>;
        default:
            return null;
    }
};

export { renderCustomizations };
